import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListItemText,
  Checkbox,
  Stack,
} from "@mui/material";
import { useParams } from "react-router";
import { toast } from "react-toastify";
import useGenerateQueryMutation from "../../hooks/useGenerateQueryMutation";

const roles = ["Inv_coordinator", "Investigator", "Sub_investigator"];

const roleDisplayNames = {
  Inv_coordinator: "CRC",
  Investigator: "Investigator",
  Sub_investigator: "Sub-Investigator",
};

const GenerateQueryPopUp = ({ showRolesModal, setShowRolesModal, answerJsonId, trialId }) => {
  const [selectedRoles, setSelectedRoles] = useState(["Inv_coordinator"]);
  const { _id_ } = useParams();
  const generateQueryMutation = useGenerateQueryMutation();

  const userRoleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedRoles(typeof value === "string" ? value.split(",") : value);
  };

  const handleGenerateQuery = () => {
    if (selectedRoles.length === 0) {
      toast.error("Select Role for Generating a Query");
      return;
    }
    generateQueryMutation.mutate(
      {
        user_roles: selectedRoles,
        answerjson_id: answerJsonId,
        trial_id: trialId,
        patient_id: _id_,
      },
      {
        onSuccess: (data) => {
          setShowRolesModal(false);
          toast.success(data.message);
        },
        onError: () => {
          toast.error("Something went wrong");
        },
      }
    );
  };

  return (
    <Dialog open={showRolesModal} onClose={() => setShowRolesModal(false)} maxWidth="sm" fullWidth>
      <DialogTitle>Generate a Query</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <FormControl size="small" fullWidth>
            <InputLabel>Select Recipient Roles</InputLabel>
            <Select
              label="Select Recipient Roles"
              multiple
              value={selectedRoles}
              onChange={userRoleChange}
              renderValue={(selected) => selected.map((name) => roleDisplayNames[name]).join(", ")}
            >
              {roles.map((name) => (
                <MenuItem key={name} value={name}>
                  <Checkbox checked={selectedRoles.indexOf(name) > -1} />
                  <ListItemText primary={roleDisplayNames[name]} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleGenerateQuery}>
          Generate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GenerateQueryPopUp;
